import { render, staticRenderFns } from "./PriceLists.vue?vue&type=template&id=336b36a3&scoped=true&"
import script from "./PriceLists.vue?vue&type=script&lang=js&"
export * from "./PriceLists.vue?vue&type=script&lang=js&"
import style0 from "./PriceLists.vue?vue&type=style&index=0&id=336b36a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336b36a3",
  null
  
)

export default component.exports